import { PriceBookDeleteConflict } from "../../../types/price-book.type";

/**
 * What the user has to do before a pricebook can be deleted: its stores are assigned on the
 * customer page, so that is where they have to be moved off it. Shared by the row's
 * disabled-delete tooltip and the 409 message so both read the same.
 *
 * `branchCount` is only known from a refusal, which counts the branches those stores sit in.
 */
export const buildStoreBlockerMessage = (
  storeCount: number,
  branchCount?: number,
): string => {
  const branchScope = branchCount ? ` ใน ${branchCount} สาขา` : "";
  return `ถอดร้านค้า ${storeCount} ราย${branchScope} ที่หน้าลูกค้าก่อน`;
};

/**
 * Spells out, in Thai, why the API refused a pricebook delete. Stores still using the
 * pricebook are the only business rule left; a refusal without a store count is the
 * platform's reserved-code rule.
 *
 * `fallbackCode` labels the pricebook when the refusal carries no code of its own.
 */
export const buildPriceBookConflictMessage = (
  conflict: PriceBookDeleteConflict,
  fallbackCode: string,
): string => {
  const code = conflict.code ?? fallbackCode;
  if (!conflict.active_store_count) {
    return `ไม่สามารถลบสมุดราคา ${code} ได้ เนื่องจากเป็นสมุดราคาที่ระบบสงวนไว้`;
  }
  return `ไม่สามารถลบสมุดราคา ${code} ได้ ${buildStoreBlockerMessage(
    conflict.active_store_count,
    conflict.branch_count_in_use,
  )}`;
};
